export default __webpack_public_path__ + "static/media/rh-ico.d6afb9ba.svg";